<template lang="pug">
  
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>

<!--<template lang="pug">-->
<!--  b-modal(-->
<!--    size="lg",-->
<!--    v-model="show",-->
<!--    header-class="lmm-table-list-modal-header",-->
<!--    @hide="close"-->
<!--    hide-footer-->
<!--  )-->
<!--    template(slot="modal-header")-->
<!--      //img.logo(:src="`${AppState.Path.image}/main_logo.png`")-->
<!--      img(src="../../assets/main_logo.png" style="height: 20px")-->
<!--      b-button.close-btn(-->
<!--        variant="danger"-->
<!--        size="sm",-->
<!--        @click="close"-->
<!--      ) X-->
<!--    b-container(fluid)-->
<!--      b-row.title-->
<!--        div {{$t(this.dialog.context.path)}}-->
<!--      b-card.mt-4-->
<!--        div.header-container-->
<!--          div 장치명-->
<!--          b-form-input(type="text", placeholder="추가하는 장치 이름", v-model="deviceNameInput" @keyup.enter="searchCompanyButton")-->
<!--          b-button(variant="primary", @click="addDeviceButton") 추가-->
<!--</template>-->

<!--<script>-->
<!--import _ from "lodash";-->
<!--import AuthenticateDevicesAPI from "../../api/authenticate-devices";-->

<!--const defaultValues = {-->
<!--  size: 'sm',-->
<!--  title: '',-->
<!--  context: '',-->
<!--  headerBgVariant: 'light',-->
<!--  headerTextVariant: 'dark',-->
<!--  bodyBgVariant: 'light',-->
<!--  bodyTextVariant: 'dark',-->
<!--  footerBgVariant: 'light',-->
<!--  footerTextVariant: 'dark',-->
<!--  align: 'center'-->
<!--}-->

<!--export default {-->
<!--  name: 'new-device-registration-dialog',-->
<!--  methods: {-->
<!--    close () {-->
<!--      this.show = false-->
<!--    },-->
<!--    addDeviceButton() {-->
<!--      return console.log('추가 버튼을 눌렀음.')-->
<!--    }-->
<!--  },-->
<!--  created() {-->
<!--    this.dialog = defaultValues-->
<!--    this.AppState.$on('show-device-registration-dialog', data => {-->

<!--      this.dialog = _.assign(this.dialog, data)-->
<!--      this.show = true-->
<!--    })-->
<!--  },-->
<!--  mounted() {-->
<!--    AuthenticateDevicesAPI.get()-->
<!--        .then(resp => {-->
<!--        })-->
<!--  },-->
<!--  data() {-->
<!--    return {-->
<!--      show: false,-->
<!--      deviceNameInput: '',-->
<!--      dialog: {},-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<style scoped lang="scss">-->
<!--.title {-->
<!--  justify-content: center;-->
<!--  margin: 1rem 0 0 0;-->
<!--  > div {-->
<!--    font-size: 2rem;-->
<!--    font-weight: 550;-->
<!--    letter-spacing: 1px;-->
<!--  }-->
<!--}-->

<!--.header-container {-->
<!--  display: flex;-->
<!--  justify-content: center;-->
<!--  align-items: center;-->
<!--  height: 100%;-->

<!--  * {-->
<!--    margin: 0.5rem;-->
<!--  }-->

<!--  > div {-->
<!--    display: flex;-->
<!--    justify-content: center;-->
<!--    align-items: center;-->
<!--    width: 20%;-->
<!--    height: 38px;-->
<!--    border-radius: 0.5rem;-->
<!--    background: #9C9C9C;-->
<!--    color: #FFFFFF;-->
<!--    text-align: center;-->
<!--    font-size: 1.2rem;-->
<!--  }-->

<!--  > .form-control {-->
<!--    width: 80%;-->
<!--    border-radius: 0.5rem;-->
<!--  }-->

<!--  > .btn {-->
<!--    width: 10%;-->
<!--    border-radius: 0.5rem;-->
<!--  }-->
<!--}-->
<!--</style>-->
